<div
  *ngIf="(ownReview || isOwnReviewEdited) && isOfferConfirmed"
  class="d-flex align-items-center mb-3"
>
  <h5 class="mb-0">{{ 'externalEmployees.reviews.ownReview' | translate }}</h5>
  <div class="d-flex gap-2">
    <base-button
      class="ms-3"
      color="dark"
      icon="fa-solid {{ isOwnReviewEdited ? 'fa-check' : 'fa-pen' }}"
      [iconSize]="buttonSizes.md"
      tooltip="action.save"
      (btnClick)="addOrEditReview()"
      stateClass="pe-1"
    ></base-button>
    <base-button
      *ngIf="isOwnReviewEdited"
      color="dark"
      icon="fa-solid fa-xmark"
      [iconSize]="buttonSizes.md"
      tooltip="action.cancel"
      (btnClick)="cancelEditReview()"
      stateClass="pe-1"
    ></base-button>
  </div>
</div>
<div
  *ngIf="isOwnReviewEdited"
  class="d-flex flex-column mb-6"
>
  <form
    [formGroup]="ownRatingFormGroup"
    [ngClass]="{ 'was-validated': submitted }"
  >
    <div class="pb-2">
      <base-rating
        [hideCount]="true"
        [formControl]="getFormControl(ownRatingFormGroup.controls.rating)"
        [isInvalid]="
          (ownRatingFormGroup.get('rating')?.touched || submitted) && !!ownRatingFormGroup.get('rating')?.errors
        "
        [errorMessage]="ownRatingFormGroup.get('rating')?.errors | baseFieldValidation"
        ngDefaultControl
      ></base-rating>
    </div>
    <base-textarea
      formControlName="note"
      rows="5"
      [isRequired]="true"
      [isInvalid]="(ownRatingFormGroup.get('note')?.touched || submitted) && !!ownRatingFormGroup.get('note')?.errors"
      [errorMessage]="ownRatingFormGroup.get('note')?.errors | baseFieldValidation"
      placeholder="externalEmployees.reviews.ownReviewPlaceholder"
    ></base-textarea>
  </form>
</div>
<button
  type="button"
  *ngIf="!ownReview && !isOwnReviewEdited && isOfferConfirmed"
  class="btn btn-primary btn-full-width mb-6"
  (click)="isOwnReviewEdited = true"
>
  <i class="fa-solid fa-plus me-2"></i>
  <span class="fw-bold">{{ 'externalEmployees.reviews.submitReview' | translate }}</span>
</button>
<div
  *ngIf="ownReview && !isOwnReviewEdited && isOfferConfirmed"
  class="my-6"
>
  <ng-container *ngTemplateOutlet="reviewContent; context: { review: ownReview }"></ng-container>
</div>
<h5 class="mb-3">{{ 'externalEmployees.reviews.otherReviews' | translate }}</h5>
<div class="listview container-fluid">
  <div
    *ngFor="let review of reviews"
    class="review listview-item bg-lightest row mb-5"
  >
    <ng-container *ngTemplateOutlet="reviewContent; context: { review: review }"></ng-container>
  </div>
  <base-empty-list-row
    *ngIf="reviews && reviews.length === 0"
    [backgroundSecondary]="true"
    [hideBackgroundImage]="true"
    message="externalEmployees.reviews.reviewListEmpty"
  ></base-empty-list-row>
</div>

<ng-template
  #reviewContent
  let-review="review"
>
  <div class="d-flex align-items-center">
    <base-avatar
      [image]="review.ratedBy.avatar"
      [size]="avatarSize.medium"
      [avatarClasses]="['cursor-auto', 'me-2']"
    ></base-avatar>
    <div class="d-flex flex-column me-3">
      <span class="fw-bold">{{ review.ratedBy.firstName }} {{ review.ratedBy.lastName }}</span>
      <span
        >{{ review.updatedAt | baseFormatDate }} | {{ 'dateTime.timePrefix' | translate }}
        {{ review.updatedAt | baseFormatTime }}</span
      >
    </div>
    <base-rating
      [currentRate]="review.rating"
      [hideCount]="true"
    ></base-rating>
  </div>
  <p class="mb-0 mt-6">
    {{ review.note }}
  </p>
</ng-template>
